var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeLowSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83093 10.2178C3.29764 11.3677 3 12.6491 3 14C3 15.4685 3.3517 16.8548 3.97547 18.0794C4.27839 18.6741 4.91613 19 5.5835 19H18.4165C19.0839 19 19.7216 18.6741 20.0245 18.0794C20.6483 16.8548 21 15.4685 21 14C21 9.02944 16.9706 5 12 5C10.6769 5 9.42046 5.28551 8.28897 5.79829M11.2929 13.293C11.6834 12.9025 12.3166 12.9025 12.7071 13.293C13.0976 13.6835 13.0976 14.3167 12.7071 14.7072C12.3166 15.0978 11.6834 15.0978 11.2929 14.7072C10.9024 14.3167 10.9024 13.6835 11.2929 13.293ZM11.2929 13.293L4.92893 6.92905",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeLowSvgrepoCom);
export default __webpack_public_path__ + "static/media/gauge-low-svgrepo-com.2769397d6d2ccf87cca75656c51911d6.svg";
export { ForwardRef as ReactComponent };